import { useLayoutEffect } from 'react';
import { useBoundStore } from '../store/useBoundStore';

/** Put the focus theme on the document so dialogs and body portals inherit it. */
export default function PortalFocusTheme() {
  const theme = useBoundStore(
    (state) => state.accountPreferences.navigationTheme ?? 'light'
  );

  useLayoutEffect(() => {
    const root = document.documentElement;
    const previous = root.getAttribute('data-focus-theme');
    root.setAttribute('data-focus-theme', theme);
    return () => {
      if (previous === null) root.removeAttribute('data-focus-theme');
      else root.setAttribute('data-focus-theme', previous);
    };
  }, [theme]);

  return null;
}
